import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SlidePanelComponent } from './components/slide-panel/slide-panel.component';
import { CourseItemComponent } from './components/course-item/course-item.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { CommentBoxComponent } from './components/comment-box/comment-box.component'; 
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SmallSpinnerComponent } from './components/small-spinner/small-spinner.component';
import { MyCourseItemComponent } from './components/my-course-item/my-course-item.component';
import { MenuComponent } from './components/menu/menu.component';
import { TeacherItemComponent } from './components/teacher-item/teacher-item.component';
import { KnowledgeItemComponent } from './components/knowledge-item/knowledge-item.component';
import { BecomeInstructorComponent } from './components/become-instructor/become-instructor.component';
import { EnglishCourseItemComponent } from './components/english-course-item/english-course-item.component';
import { ImageUploaderComponent } from './components/image-uploader/image-uploader.component';
import { FacebookModule } from '@greg-md/ng-facebook';
import { ReplyCommentDialogComponent } from './components/reply-comment-dialog/reply-comment-dialog.component';
import { QuizDialogComponent } from './components/quiz-dialog/quiz-dialog.component';
import { QuizItemComponent } from './components/quiz-item/quiz-item.component';
import { QuizResultComponent } from './components/quiz-result/quiz-result.component';
import { QuizHistoryComponent } from './components/quiz-history/quiz-history.component';
import { DialogSlidePanelComponent } from './components/dialog-slide-panel/dialog-slide-panel.component';
import { SearchBoxComponent } from './components/dictionary/search-box/search-box.component';
import { WordDetailComponent } from './components/dictionary/word-detail/word-detail.component';


@NgModule({
  declarations: [
    FooterComponent,
    NavbarComponent,
    SpinnerComponent,
    SlidePanelComponent,
    CourseItemComponent,
    VideoPlayerComponent,
    CommentBoxComponent,
    SmallSpinnerComponent,
    MyCourseItemComponent,
    MenuComponent,
    TeacherItemComponent,
    KnowledgeItemComponent,
    BecomeInstructorComponent,
    EnglishCourseItemComponent,
    ImageUploaderComponent,
    ReplyCommentDialogComponent,
    QuizDialogComponent,
    QuizItemComponent,
    QuizResultComponent,
    QuizHistoryComponent,
    DialogSlidePanelComponent,
    SearchBoxComponent,
    WordDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    FacebookModule
  ],
  exports:[
    FooterComponent,
    NavbarComponent,
    SpinnerComponent,
    SlidePanelComponent,
    CourseItemComponent,
    VideoPlayerComponent,
    CommentBoxComponent,
    SmallSpinnerComponent,
    MyCourseItemComponent,
    MenuComponent,
    TeacherItemComponent,
    KnowledgeItemComponent,
    BecomeInstructorComponent,
    EnglishCourseItemComponent,
    ImageUploaderComponent,
    ReplyCommentDialogComponent,
    QuizDialogComponent,
    QuizItemComponent,
    QuizResultComponent,
    QuizHistoryComponent,
    DialogSlidePanelComponent,
    SearchBoxComponent,
    WordDetailComponent
  ]
})
export class SharedModule { }
